import React from "react"
import { useTaskReportExportContext } from "contexts/TaskReportExportContext"
import { yearMonthDayDate } from "utils/dateHelpers"
import { DateInput } from "shared/inputs"

const NewTaskReportExportDueDateFilters = () => {
  const {
    earliestDueDate,
    latestDueDate,
    setEarliestDueDate,
    setLatestDueDate,
  } = useTaskReportExportContext()

  return (
    <>
      <label aria-label="earliest due date (mm/dd/yyyy)">
        <span aria-hidden>Earliest Date:</span>
        <DateInput
          className="mb-4"
          clearable
          max={latestDueDate ? yearMonthDayDate(latestDueDate) : null}
          name="task_report_export_earliest_due_date"
          onChange={setEarliestDueDate}
          value={earliestDueDate}
        />
      </label>
      <label aria-label="latest due date (mm/dd/yyyy)">
        <span aria-hidden>Latest Date:</span>
        <DateInput
          className="mb-4"
          clearable
          min={earliestDueDate ? yearMonthDayDate(earliestDueDate) : null}
          name="task_report_export_latest_due_date"
          onChange={setLatestDueDate}
          value={latestDueDate}
        />
      </label>
    </>
  )
}

export default NewTaskReportExportDueDateFilters
